"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WordShortcut = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const WordShortcutSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#word-shortcut__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#185ABD",
      fillRule: "evenodd",
      d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.088 9.065v-.572h.034l.602.001.288.001.296.002c.195 0 .381.003.53.005 2.285.043 3.297 1.123 3.37 2.983a9 9 0 0 0-1.4-1.095c-.35-.705-1.044-.992-1.992-.992h-.163a9 9 0 0 0-1.565-.333m7.24 5.519c.463.33 1.046.506 1.724.506 1.786 0 2.898-1.246 2.898-3.33 0-2.106-1.125-3.357-2.898-3.357-1.778 0-2.925 1.256-2.925 3.357q0 .44.065.828c.46.61.843 1.28 1.137 1.996m0-2.81c0 1.683.666 2.398 1.724 2.398 1.066 0 1.705-.715 1.705-2.398 0-1.71-.648-2.453-1.705-2.453-1.058 0-1.724.747-1.724 2.453m10.917 1.066c-.148 1.184-.86 2.25-2.565 2.25-1.79 0-2.866-1.3-2.866-3.384 0-2.079 1.066-3.303 2.866-3.303 1.422 0 2.44.963 2.565 2.178H20.09c-.13-.715-.617-1.26-1.44-1.26-1.035 0-1.625.702-1.625 2.399 0 1.71.59 2.452 1.625 2.452.823 0 1.31-.612 1.44-1.332z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "word-shortcut__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
const WordShortcut = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: WordShortcutSvg
}));
exports.WordShortcut = WordShortcut;